import Axios from "axios";

/* const url_categories_dev =; */
 import { sortCaret } from "../../../_metronic/_helpers";

 const url_tasks = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/reports";
console.log(process.env.NODE_ENV);


export const columns = [
  {
    dataField: "name",
    text: "Reports Title",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "description",
    text: "Description",
    sort: true,
    sortCaret: sortCaret,
  },
];

export function getClients(setCategory) {
  Axios.get(`${url_tasks}/find`)
    .then((res) => {
      const categories = res.data.payload;
      console.log(categories);
      setCategory(categories);
    })
    .catch(function (thrown) {
      if (Axios.isCancel(thrown)) {
        console.log(`request cancelled:${thrown.message}`)
      } else {
        console.log('another error happened')
      }
    })
}
export function getClient(uid = "") {
  return Axios.get(`${url_tasks}/find/${uid}`);
}
export function updateClient(reports) {
  if (reports.uid) {
    return Axios.put(`${url_tasks}/update/${reports.uid}`, reports);
  } else {
    return Axios.post(`${url_tasks}/create`, reports);
  }
}
export function deleteClient(uid) {
  return Axios.delete(`${url_tasks}/delete/${uid}`);
}

export function populate(uids) {
  return Axios.post(`${url_tasks}/populate`, { uids });

}